import { render, staticRenderFns } from "./TenantAddProperty.vue?vue&type=template&id=1fd74df8&scoped=true&"
import script from "./TenantAddProperty.vue?vue&type=script&lang=js&"
export * from "./TenantAddProperty.vue?vue&type=script&lang=js&"
import style0 from "./TenantAddProperty.vue?vue&type=style&index=0&id=1fd74df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd74df8",
  null
  
)

export default component.exports